import { SECURE_WEBSITE_PROTOCOL_PREFIX, UNSECURE_WEBSITE_PROTOCOL_PREFIX } from '../../constants/http';
import { isLocal } from '../env/checkEnvironmentType';

export const addHostProtocolToDomain = (domain: string): string => {

  if (
    domain.startsWith(UNSECURE_WEBSITE_PROTOCOL_PREFIX) ||
    domain.startsWith(SECURE_WEBSITE_PROTOCOL_PREFIX)
  ) {

    return domain;
  
  }

  return isLocal()
    ? `${UNSECURE_WEBSITE_PROTOCOL_PREFIX}${domain}`
    : `${SECURE_WEBSITE_PROTOCOL_PREFIX}${domain}`;

};
